// src/DatabaseAdmin/Sidebar.jsx
import PropTypes from 'prop-types';
import styles from './Sidebar.module.scss';

const Sidebar = ({
  activeSection,
  setActiveSection,
  tables,
  selectedTable,
  onTableSelect,
  users,
  selectedUser,
  onUserSelect,
}) => {
  return (
    <div className={styles.sidebar_DatabaseAdmin}>
      <h2 className={styles.title_DatabaseAdmin}>Настройка</h2>

      <div className={styles.viewModeToggle}>
        <button
          className={`${styles.viewModeButton} ${activeSection === 'info' ? styles.selected_DatabaseAdmin : ''}`}
          onClick={() => setActiveSection('info')}
        >
          Инфо
        </button>
        <button
          className={`${styles.viewModeButton} ${activeSection === 'users' ? styles.selected_DatabaseAdmin : ''}`}
          onClick={() => setActiveSection('users')}
        >
          Пользователи
        </button>
        <button
          className={`${styles.viewModeButton} ${activeSection === 'activity' ? styles.selected_DatabaseAdmin : ''}`}
          onClick={() => setActiveSection('activity')}
        >
          Активность
        </button>
        <button
          className={`${styles.viewModeButton} ${activeSection === 'tables' ? styles.selected_DatabaseAdmin : ''}`}
          onClick={() => setActiveSection('tables')}
        >
          Таблицы
        </button>
      </div>

      {activeSection === 'info' && (
        <p style={{ margin: '8px 0 0', color: '#4b5563', lineHeight: 1.4 }}>
          Сводная информация по регионам и пабликам.
        </p>
      )}

      {activeSection === 'tables' && (
        <>
          <h3 className={styles.subtitle_DatabaseAdmin}>Таблицы</h3>
          <div className={styles.tableList_DatabaseAdmin}>
            {tables.map((table) => (
              <button
                key={table}
                className={`${styles.tableOption_DatabaseAdmin} ${selectedTable === table ? styles.selected_DatabaseAdmin : ''}`}
                onClick={() => onTableSelect(table)}
              >
                {table}
              </button>
            ))}
          </div>
        </>
      )}

      {activeSection === 'users' && (
        <div style={{ marginTop: 24 }}>
          <h3 style={{ fontSize: 18, fontWeight: 500, color: '#1f2a44', marginBottom: 8 }}>Пользователь</h3>
          <select
            value={selectedUser ? selectedUser.id : ''}
            onChange={e => {
              const user = users.find(u => String(u.id) === e.target.value);
              onUserSelect(user);
            }}
            style={{ width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 14 }}
          >
            <option value="">Выберите пользователя</option>
            {users.map(u => (
              <option key={u.id} value={u.id}>{u.username}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

Sidebar.propTypes = {
  activeSection: PropTypes.string.isRequired,
  setActiveSection: PropTypes.func.isRequired,
  tables: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedTable: PropTypes.string.isRequired,
  onTableSelect: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired,
  selectedUser: PropTypes.object,
  onUserSelect: PropTypes.func.isRequired,
};

export default Sidebar;
